import { memo } from 'react';
import type { LaidOutRibbon } from '@/layout/types';

interface Props {
  ribbon: LaidOutRibbon;
  dimmed: boolean;
  selected: boolean;
  onActivate: (ribbon: LaidOutRibbon) => void;
  onHover: (ribbon: LaidOutRibbon | null, event?: React.MouseEvent) => void;
}

/**
 * A ribbon draws twice: the visible fill, plus a transparent stroked copy that
 * widens the hit area so a two-pixel thread is still clickable.
 */
export const Ribbon = memo(function Ribbon({
  ribbon,
  dimmed,
  selected,
  onActivate,
  onHover,
}: Props) {
  const className = [
    'ribbon',
    `tone-${ribbon.tone}`,
    ribbon.kind === 'overlay' ? 'is-overlay' : '',
    selected ? 'is-selected' : '',
    dimmed ? 'is-dimmed' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <g
      onClick={() => onActivate(ribbon)}
      onMouseEnter={(event) => onHover(ribbon, event)}
      onMouseMove={(event) => onHover(ribbon, event)}
      onMouseLeave={() => onHover(null)}
    >
      <path className={className} d={ribbon.d} />
      <path className="ribbon-hit" d={ribbon.d} aria-hidden="true" />
    </g>
  );
});
